import type { NPCConfig } from '@/entities';

const config: NPCConfig[] = [
  {
    x: 1680,
    y: 1560,
    name: 'Elsa',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_elsa.png', // Use NPC image
    repeatable : false,
    flipSprite : true,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Halo Yan selamat pagi.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Sejak pagi aku sakit perut, sudah bolak balik beberapa kali ke toilet`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_3",
        },
        elsa_3: {
          id: 'elsa_2',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Apa kamu tidak apa-apa?',
              nextDialogId: 'elsa_a1',
              storyAction: { type: 'addCustomValue', value: {key : "elsa_affinity", value : 1} },
            },
            {
              text: 'Diana dimana?',
              nextDialogId: 'elsa_b1',
            },
          ],
        },
        elsa_a1: {
          id: 'elsa_a1',
          speaker: 'Elsa',
          text: `Tidak apa-apa, mungkin perutku kurang cocok dengan makanan disini.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd :true,
        },
        elsa_b1: {
          id: 'elsa_a1',
          speaker: 'Elsa',
          text: `Seharusnya masih tidur di kamarnya`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd :true,
        },
      },
    },
  },
  {
    x: 1780,
    y: 1530,
    name: 'Nenek',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_nenek2.png', // Use NPC image
    repeatable : false,
    flipSprite : true,
    dialogTree: {
      startDialogId: 'nenek_1',
      nodes: {
        nenek_1: {
          id: 'nenek1',
          speaker: 'Nenek',
          text: `Selamat pagi Yan, bagaimana tidur mu?`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_2",
          //TODO nenek ga keriput
        },
        nenek_2: {
          id: 'nenek1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Tidur ku baik nek. Apakah nenek sudah lebih sehat?',
              nextDialogId: 'nenek_3',
            },
            {
              text: 'Apa kabar nenek?',
              nextDialogId: 'nenek_3',
            },
          ],
        },
        nenek_3: {
          id: 'nenek1',
          speaker: 'Nenek',
          text: `Baik, hari ini nenek bangun sangat segar dan beenergi`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_4",
        },
        nenek_4: {
          id: 'nenek1',
          speaker: 'Nenek',
          text: `Sepertinya nenek sudah hampir sembuh.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd: true
        },
      },
    },
  },
  {
    x: 1930,
    y: 1380,
    name: '',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_holga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'holga_1',
      //TODO kalau bisa ini dibuat next day juaga, tp beginning dialog besoknya harus di adjust biar bisa kosong
      nodes: {
        holga_1: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `...`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "holga_2",
          storyAction: { type: 'addState', value: "HOLGA_FOUND_MORNING" },
        },
        holga_2: {
          id: 'holga_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Selamat pagi Bu',
              nextDialogId: 'holga_3',
            },
            {
              text: 'Apa yang sedang Ibu lakukan disini?',
              nextDialogId: 'holga_3',
            },
          ],
        },
        holga_3: {
          id: 'holga_3',
          speaker: 'Holga',
          text: `Pagi, saya ada urusan.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId: 'holga_4',
        },
        holga_4: {
          id: 'holga_3',
          speaker: 'Holga',
          text: `Saya izin pergi dulu.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 2100,
    y: 1530,
    name: 'Romo Darius',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_darius.png', // Use NPC image
    dialogTree: {
      startDialogId: 'romo_1',
      nodes: {
        romo_1: {
          id: 'romo_1',
          speaker: 'Romo Darius',
          text: `Selamat pagi Yan. `,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "romo_2",
        },
        romo_2: {
          id: 'romo_1',
          speaker: 'Romo Darius',
          text: `Apa yang sedang kamu lakukan pagi-pagi`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "romo_3",
        },
        romo_3: {
          id: 'romo_3',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Aku sedang lari pagi',
              nextDialogId: 'romo_4',
            },
            {
              text: 'Aku sedang mencari udara segar',
              nextDialogId: 'romo_4',
            },
          ],
        },
        romo_4: {
          id: 'romo_3',
          speaker: 'Romo Darius',
          text: `Baiklah, hati-hati ya, hari masih gelap.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/desa.png',
          storyAction: { type: 'nextDay', value: 0 },
        },
      },
    },
  },
];

export default config;
